export const COORDINATION_TYPE = {
    FIND: 'FIND_COORDINATION_TYPE',    
    GET_ACTIVE: 'GET_ACTIVE_COORDINATION_TYPE',
    GET_ALL: 'GET_ALL_COORDINATION_TYPE',
    CHANGE_STATUS: 'CHANGE_STATUS_COORDINATION_TYPES',
    SUCCESS: 'SUCCESS_COORDINATION_TYPE',
    ERROR: 'ERROR_COORDINATION_TYPE',
    CLEAN: 'CLEAN_COORDINATION_TYPE',
}